import { gql } from '@apollo/client';

const transferNFTMutation = gql `
    mutation (
      $walletId: UUID1!
      $orgId: UUID1!
      $contractAddress: String!
      $tokenType: TokenType
      $tokenOnChainId: Int!
      $amount: Int
      $transferTo: String!
      $isClaimedToken: Boolean
    ) {
      transferToken(
        walletId: $walletId
        orgId: $orgId
        contractAddress: $contractAddress
        tokenType: $tokenType
        tokenOnChainId: $tokenOnChainId
        amount: $amount
        transferTo: $transferTo
        isClaimedToken: $isClaimedToken
      )
    }
  `;

export { transferNFTMutation };
